<template>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-text class="pa-6">
          <!-- Project Info Section -->
          <v-row no-gutters class="mb-4">
            <v-col cols="2" class="grey--text text--darken-2 font-weight-medium">프로젝트명</v-col>
            <v-col cols="10">
              <div class="grey lighten-3 pa-2">{{ projectInfo.name }}</div>
            </v-col>
          </v-row>
  
          <v-row no-gutters class="mb-6">
            <v-col cols="2" class="grey--text text--darken-2 font-weight-medium">프로젝트<br>기간</v-col>
            <v-col cols="10">
              <div class="grey lighten-3 pa-2">
                {{ formatDate(projectInfo.startDate) }} ~ {{ formatDate(projectInfo.endDate) }}
              </div>
            </v-col>
          </v-row>
  
          <!-- Team Members Table -->
          <div class="mb-6">
            <div class="mb-2 grey--text text--darken-2 font-weight-medium">투입 인원</div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>No</th>
                    <th>소속</th>
                    <th>직급</th>
                    <th>성명</th>
                    <th>서비스 지원분야</th>
                    <th>프로젝트 역할</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(member, index) in teamMembers" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ member.department }}</td>
                    <td>{{ member.position }}</td>
                    <td>{{ member.name }}</td>
                    <td>{{ member.serviceArea }}</td>
                    <td>{{ member.role }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
  
          <!-- Crawling Keywords -->
            <!-- <div class="mb-6">
              <div class="mb-2 grey--text text--darken-2 font-weight-medium">크롤링 키워드 등록</div>
              <v-text-field
                outlined
                dense
                hide-details
                class="mb-2"
              ></v-text-field>
              <div class="mb-2 d-flex align-center">
                <v-btn small color="primary" class="mr-2">AND</v-btn>
                <v-btn small color="primary" class="mr-2">NOT</v-btn>
                <v-btn small>등록</v-btn>
              </div>
              <div class="flex-wrap d-flex">
                <v-chip
                  v-for="source in sources"
                  :key="source"
                  class="mb-2 mr-2"
                  small
                  outlined
                >
                  {{ source }}
                </v-chip>
              </div>
            </div> -->
  
          <!-- Crawling Period -->
          <!-- <div class="mb-6">
            <div class="mb-2 grey--text text--darken-2 font-weight-medium">크롤링 기간</div>
            <div class="d-flex align-center">
              <v-text-field
                label="Start"
                outlined
                dense
                hide-details
                class="mr-2"
                style="width: 150px"
              ></v-text-field>
              <v-text-field
                label="End"
                outlined
                dense
                hide-details
                class="mr-2"
                style="width: 150px"
              ></v-text-field>
              <div class="mr-2">주기</div>
              <v-text-field
                value="1week/1month"
                outlined
                dense
                hide-details
                style="width: 150px"
              ></v-text-field>
            </div>
          </div> -->
  
          <!-- Crawling Path -->
          <div class="mb-6">
            <div class="mb-2 grey--text text--darken-2 font-weight-medium">LUCY</div>
            <div class="d-flex align-center">
              <v-text-field
                v-model="lucyFilePath"
                outlined
                dense
                hide-details
                class="mr-2"
                readonly
              ></v-text-field>
              <v-btn small class="mr-2" @click="triggerFileInput">Load Lucy</v-btn>
              <v-btn 
                small 
                color="pink lighten-3" 
                @click="startCrawling"
                :loading="isProcessing"
                :disabled="!lucyFile"
              >
                크롤링 시작
              </v-btn>
              <input
                type="file"
                ref="fileInput"
                style="display: none"
                @change="handleFileUpload"
                accept=".xlsx,.xls,.csv"
              >
            </div>
          </div>
  
          <!-- Crawling History -->
          <div class="mb-6">
            <div class="mb-2 grey--text text--darken-2 font-weight-medium">크롤링 현황</div>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>기간</th>
                    <th>Lucy 파일</th>
                    <th>상태</th>
                    <th>진행률</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="job in projectInfo.crawlingJobs" :key="job.id">
                    <td>{{ formatJobPeriod(job) }}</td>
                    <td>{{ formatLucyPath(job.lucy_path) }}</td>
                    <td>{{ formatStatus(job.status) }}</td>
                    <td>{{ formatProgress(job) }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </div>
  
          <!-- Keywords -->
          <!-- <div>
            <div class="mb-2 grey--text text--darken-2 font-weight-medium">키워드</div>
            <div class="flex-wrap d-flex">
              <v-chip
                v-for="keyword in keywords"
                :key="keyword"
                color="light-blue"
                text-color="white"
                class="mb-2 mr-2"
                small
              >
                {{ keyword }}
                <v-icon small class="ml-1">mdi-close</v-icon>
              </v-chip>
            </div>
          </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { ref, computed, watch } from 'vue'
  import { useStore } from 'vuex'
  import { mapActions } from 'vuex';


  export default {
    name: 'ProjectDetailModal',


    
    props: {
      modelValue: {
      type: Boolean,
      required: true
    },
      projectData: {
        type: Object,
        required: true,
        default: () => ({})
      }
    },
    emits: ['update:modelValue', 'close'],
    computed: {
    dialog: {
      get() {
        console.log('Dialog getter called:', this.modelValue) // Debug
        return this.modelValue
      },
      set(value) {
        console.log('Dialog setter called:', value) // Debug
        this.$emit('update:model-value', value)
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },

  // Add mounted hook to verify component mounting
  mounted() {
    console.log('ProjectDetailModal mounted:', {
      modelValue: this.modelValue,
      projectData: this.projectData
      })
    },
    
    setup(props) {
      const store = useStore()
      const fileInput = ref(null)
      const lucyFilePath = ref('')
      const lucyFile = ref(null)
      
      const isProcessing = computed(() => store.state.crawling.isProcessing)
      const isUploading = computed(() => store.state.crawling.isUploading)
      const uploadError = computed(() => store.state.crawling.uploadError)
      watch(() => props.modelValue, (newValue) => {
        if (newValue) {
          // Reset Lucy file state when modal opens
          lucyFile.value = null
          lucyFilePath.value = ''
          if (fileInput.value) {
            fileInput.value.value = '' // Reset file input
          }
        }
      })

      const triggerFileInput = () => {
      fileInput.value.click()
      }

      const handleFileUpload = (event) => {
        const file = event.target.files[0]
        if (file) {
          lucyFile.value = file
          lucyFilePath.value = file.name
        }
      }

      const startCrawling = async () => {
        if (!lucyFile.value) {
          store.commit('message/showMessage', {
            title: '오류',
            content: 'LUCY 파일을 선택해주세요.'
          })
          return
        }

        try {
          await store.dispatch('crawling/startCrawling', {
            file: lucyFile.value,
            selected_project_id: props.projectData.id
          })
          this.$emit('show-message', {
            title: '성공',
            content: '크롤링 등록이 성공하였습니다.'
          })
          console.log('Event emitted: show-message')
        } catch (error) {
          this.$emit('show-message', {
            title: '오류',
            content: error.message || '크롤링 시작 중 오류가 발생했습니다.'
          })
          console.log('Event emitted: show-message with error')
        }
      }

      const projectInfo = computed(() => ({
        name: props.projectData?.name || 'N/A',
        startDate: props.projectData?.start_date || '',
        endDate: props.projectData?.end_date || '',
        description: props.projectData?.description || 'N/A',
        status: props.projectData?.status || 'N/A',
        type: props.projectData?.type || 'N/A',
        crawlingJobs: props.projectData?.crawling_jobs || [], 
        participant_ids: props.projectData?.participant_ids || []
      }))

      const formatDate = (dateString) => {
        if (!dateString) return 'N/A'
        const date = new Date(dateString)
        return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`
      }

      const formatJobPeriod = (job) => {
        const startDate = job.started_at ? new Date(job.started_at) : new Date(job.created_at)
        const endDate = job.completed_at ? new Date(job.completed_at) : null
        
        const formatDate = (date) => {
          return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`
        }
        
        return endDate ? `${formatDate(startDate)} ~ ${formatDate(endDate)}` : formatDate(startDate)
      }

      const formatLucyPath = (path) => {
        return path.split('/').pop() // Get filename only
      }

      const formatStatus = (status) => {
        const statusMap = {
          'started': '진행중',
          'completed': '완료',
          'error': '오류',
          'pending': '대기중'
        }
        return statusMap[status] || status
      }

      const formatProgress = (job) => {
        if (!job.total_items) return '-'
        const processed = job.processed_items || 0
        const total = job.total_items
        return `${processed}/${total}`
      }

      return {
        projectInfo,
        formatDate,
        fileInput,
        lucyFilePath,
        lucyFile,
        isProcessing,
        isUploading,
        uploadError,
        triggerFileInput,
        handleFileUpload,
        startCrawling,
        formatJobPeriod,
        formatLucyPath,
        formatStatus,
        formatProgress
      }
    },
    
    data() {
      return {
        teamMembers: []
      }
    },
    methods: {
      ...mapActions('project', ['fetchParticipantsByIds']),
      async loadParticipants() {
        if (this.projectInfo && this.projectInfo.participant_ids) {
          try {
            const participants = await this.fetchParticipantsByIds(this.projectInfo.participant_ids);
            this.teamMembers = participants;
          } catch (error) {
            console.error('Failed to load participants:', error);
          }
        }
      }
    },
    watch: {
      'projectInfo.participant_ids': {
        immediate: true,
        handler(newIds) {
          if (newIds && newIds.length > 0) {
            this.loadParticipants();
          }
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .v-data-table :depp(th) {
    font-weight: normal !important;
    white-space: nowrap;
  }
  
  .v-text-field :deep(.v-input__slot) {
    min-height: 32px !important;
  }
  </style>

